import React, { Component } from "react";
import { Popover } from "react-bootstrap";
import { IconButton } from "material-ui";
import "./IconPopover.css";
import IconConfig from "../configs/IconConfig";

export default class IconPopover extends Component {

  renderAllIcons = () => {
    return IconConfig.Icons.map((icon, index) => {
      return this.renderIcon(icon, index);
    });
  }

  highlightIcon = (event) => {

    // Get the correct element for the highlighting
    var element = event.target.closest("svg");

    // Find any selected icons and remove the class
    var selectedIcons = document.getElementsByClassName("selected-icon");
    if(selectedIcons !== null && selectedIcons.length > 0) {
      for(let item of selectedIcons) {
          item.classList.remove("selected-icon");
      }
    }

    // Add class to the selected element
    element.classList.add("selected-icon");

    // Close Popover
    document.body.click();
  }

  renderIcon = (Icon, index) => {
    return <IconButton key={index} id={"IconButton." + Icon.Name} onClick={this.highlightIcon}>
      <Icon.Icon name={Icon.Name} id={"IconSVG." + Icon.Name} onClick={this.highlightIcon}/>
    </IconButton>
  }

  render() {
    return (
      <Popover id="popover-trigger-click-root-close" title="Icon Selector" {...this.props}>
        {this.renderAllIcons()}
      </Popover>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IconPopover.js